export const PIPE_STATUS_UNGROUPED_TOKEN = '__ungrouped__';

export type OverviewEndPresenceFilter = 'all' | 'both' | 'endAOnly' | 'endBOnly';
export type OverviewFlagFilter = 'all' | 'yes' | 'no';

export interface PipeStatusOverviewBucket {
  groupId: string;
  totalPipes: number;
  both: number;
  endAOnly: number;
  endBOnly: number;
  bothFlange?: number;
  bothArchive?: number;
  endAOnlyFlange?: number;
  endAOnlyArchive?: number;
  endBOnlyFlange?: number;
  endBOnlyArchive?: number;
}

export interface PipeStatusOverviewSummary extends PipeStatusOverviewBucket {
  groupCount: number;
}

export interface PipeStatusOverviewResponse {
  projectNumber?: string | null;
  pipeId?: number | null;
  summary: PipeStatusOverviewSummary;
  groups: PipeStatusOverviewBucket[];
  availableGroupIds: string[];
}

export interface PipeStatusOverviewQuery {
  projectId?: string | number | null;
  /** @deprecated Prefer pipeIds for multi select */
  pipeId?: string | number | null;
  /** Multi material pipe-size ids (empty = all pipe sizes in project). */
  pipeIds?: Array<string | number>;
  projectNumber?: string | null;
  projectName?: string | null;
  includeArchived?: boolean;
  groupIds?: string[];
  endPresence?: OverviewEndPresenceFilter;
  flange?: OverviewFlagFilter;
}

export function encodeOverviewGroupIdForQuery(groupId: string): string {
  return groupId === '' ? PIPE_STATUS_UNGROUPED_TOKEN : groupId;
}

export function formatOverviewGroupLabel(groupId: string): string {
  return groupId === '' ? 'Ungrouped' : groupId;
}

export function pipeEndPresenceFlagSuffixText(
  flangeCount: number,
  archiveCount: number
): string {
  if (flangeCount <= 0 && archiveCount <= 0) return '';
  const parts: string[] = [];
  if (flangeCount > 0) parts.push(`F: ${flangeCount}`);
  if (archiveCount > 0) parts.push(`A: ${archiveCount}`);
  return ` (${parts.join(' ')})`;
}

/** Pipe-end upload activity charts (createdAt + rescan). */
export type PipeUploadActivityTimeRange = 'all' | '7' | '14' | '30';

export const PIPE_UPLOAD_ACTIVITY_TIME_RANGE_LABELS: Record<
  PipeUploadActivityTimeRange,
  string
> = {
  all: 'All time',
  '30': '30 days',
  '14': '14 days',
  '7': '7 days',
};

export interface PipeUploadActivityPoint {
  key: string;
  label: string;
  uploads: number;
  firstIngest: number;
  rescan: number;
  /** Pipe ends in this bucket with more than one scanVersion. */
  duplicates?: number;
}

export interface PipeUploadActivityResponse {
  timeRange: PipeUploadActivityTimeRange;
  timezone: string;
  kpis: {
    uploadsInPeriod: number;
    firstIngests: number;
    rescans: number;
    activeDays: number;
    /** Unique pipe ends (same group + pipeEndID) with 2+ scan versions. */
    duplicatePipeEnds: number;
    /** Extra version rows beyond v1. */
    extraVersions: number;
  };
  daily: PipeUploadActivityPoint[];
  /** Upload counts by group ID (horizontal bar chart). */
  byGroup: PipeUploadActivityPoint[];
}

export interface PipeUploadActivityQuery {
  projectId?: string | number | null;
  projectNumber?: string | null;
  projectName?: string | null;
  pipeIds?: Array<string | number>;
  timeRange?: PipeUploadActivityTimeRange;
}
